{	
	title: { "en": "NFI Downloader",
		"es": "Descarga IFN"},
	local: { "en": "en",	
		"es": "es"},
	plotsSelected: { "en": "plots selected",	
		"es": "parcelas seleccionadas"},		
	download: { "en": "Download",	
		"es": "Descargar"},
	menu: { "en": "Menu",
		"es": "Menú"},
	home: { "en": "Home",
		"es": "Inicio"},
	homelocrel: { "en": "..",
		"es": "../es"},	
	
	
	IFN2: { "en": "NFI2",
		"es": "IFN2"},
	IFN3: { "en": "NFI3",
		"es": "IFN3"},
	IFN4: { "en": "NFI4",
		"es": "IFN4"},
	plotsIFN2: { "en": "NFI2 plots",
		"es": "parcelas IFN2"},
	plotsIFN3: { "en": "NFI3 plots",
		"es": "parcelas IFN3"},
	plotsIFN4: { "en": "NFI4 plots",
		"es": "parcelas IFN4"},
		
		
	toastIFN2: { "en": "In NFI2, the plots in Asturias, Cantabria, Navarra, and the Balearic Islands are not geolocated.",
		"es": "En el IFN2, las parcelas de Asturias, Cantabria, Navarra y Baleares no están geolocalizadas."},
	
		
	
	starting: { "en": 'Starting "NFI Downloader"',
		"es": 'Iniciando "Descarga IFN"'},
	confdata: { "en": "Configuring data services",
		"es": "Configurando los servicios de datos"},
	conftaxon: { "en": "Extracting taxonomic data",
		"es": "Extrayendo datos de taxones"},
	confprov: { "en": "Extracting province data",
		"es": "Extrayendo datos de provincias"},
	confmun: { "en": "Extracting municipality data",
		"es": "Extrayendo datos de municipios"},
	downloadingPlots: { "en": "Downloading map plots...",
		"es": "Descargando parcelas del mapa..."},
	downloading: { "en": "Downloading",
		"es": "Descargando"},
	downloadingPolygon: { "en": "Downloading polygon...",
		"es": "Descargando polígono..."},
	
		
	ifnversion: { "en": "NFI edition",
		"es": "Edición del IFN"},
	selectLayer: { "en": "Select layer",
		"es": "Seleccionar capa",
		"pt": "Selecione a camada"},
	mapType: { "en": "Map type",
		"es": "Tipo de mapa",
		"pt": "Tipo de mapa"},
	default: { "en": "Default",
		"es": "Predeterminado",
		"pt": "Predeterminado"},
	satellite: { "en": "Satellite",
		"es": "Satélite",
		"pt": "Satélite"},
	mapDetails: { "en": "Map details",
		"es": "Detalles del mapa",
		"pt": "Detalhes do mapa"},
	municipalities: { "en": "Municipalities",
		"es": "Municipios",
		"pt": "Municípios"},
	provinces: { "en": "Provinces",	
		"es": "Provincias"},
	zoomin: { "en": "Zoom in",
		"es": "Más zoom",
		"pt": "Aproximar"},
	zoomout: { "en": "Zoom out",
		"es": "Menos zoom",
		"pt": "Afastar"},
	
	
	taxonfilter: { "en": "Filter taxon",	
		"es": "Filtrar taxón"},
	filter: { "en": "Filter",	
		"es": "Filtrar",
		"pt": "Filtro"},
	filteringAND: { "en": "Plots with trees of ALL selected taxa",
		"es": "Parcelas con árboles de TODOS los taxones seleccionados"},
	filteringOR: { "en": "Plots with trees of ANY selected taxon",
		"es": "Parcelas con árboles de CUALQUIER taxón seleccionado"},
	showmore: { "en": "Show more",	
		"es": "Mostrar más",	
		"pt": "Mostrar mais"},
	removefilter: { "en": "Remove filter",	
		"es": "Quitar filtro",
		"pt": "Remover filtro"},
	searchtaxon: { "en": "Search taxon...",	
		"es": "Buscar taxón...",
		"pt": "Pesquisar táxon..."},
	notaxonfound: { "en": "No taxon matched",	
		"es": "No hay taxones que coincidan",
		"pt": "Não há taxa que coincidam"},
	taxonid: { "es": "Taxon with id ",	
		"es": "Taxón con id ",
		"pt": "Táxon com id "},
	nomci: { "en": "Scientific names",	
		"es": "Nombres científicos",
		"pt": "Nomes científicos"},
	tooManyTaxons: { "en": "Filtering too many taxons!",	
		"es": "¡Demasiados filtros de taxones!",
		"pt": "Filtrando demasiados táxons!"},
	taxonAlreadyIncluded: { "en": "Taxon already included.",
		"es": "Taxón ya incluido.",
		"pt": "Táxon já incluído."},
	textTooManySpecies: { "en": "Filtering too many species of trees. Please remove one if you want to set a new filter",	
		"es": "Demasiados filtros de especies de árboles. Elimina uno si quieres poner un nuevo filtro",
		"pt": "Filtrou demasiadas espécies de árvores. Exclua uma se quiser aplicar um novo filtro"},
	speciesinfo: { "en": "Species info",	
		"es": "Información de especies",
		"pt": "Informação de espécie"},
	species: { "en": "Species",	
		"es": "Especie",
		"pt": "Espécie"},
	genus: { "en": "Genus",	
		"es": "Género",
		"pt": "Género"},
	family: { "en": "Family",	
		"es": "Familia",
		"pt": "Família"},
	class: { "en": "Class",	
		"es": "Clase",
		"pt": "Classe"},
	taxonSet: { "en": "Taxon set",
		"es": "Agrupación de taxones"},
	wikipage: { "en": "Wikipedia page",	
		"es": "Wikipedia",
		"pt": "Wikipedia"},
	
	
	plot: { "en": "Plot",
		"es": "Parcela"},
	nplots: { "en": "#plots",	
		"es": "#parcelas"},
	provinceof: { "en": "province of ",
		"es": "provincia de "},
	dataCapture: { "en": "data taken in ",
		"es": "toma de datos en "},
	dataCaptureFrom: { "en": "data from ",
		"es": "datos desde "},
	dataCaptureTo: { "en": " to ",
		"es": " a "},
	sourceifn2: { "en": 'source: <a href="https://www.miteco.gob.es/es/biodiversidad/servicios/banco-datos-naturaleza/informacion-disponible/ifn2.html">NFI2</a>',
		"es": 'fuente: <a href="https://www.miteco.gob.es/es/biodiversidad/servicios/banco-datos-naturaleza/informacion-disponible/ifn2.html">IFN2</a>'},
	sourceifn3: { "en": 'source: <a href="https://www.miteco.gob.es/es/biodiversidad/servicios/banco-datos-naturaleza/informacion-disponible/ifn3.html">NFI3</a>',
		"es": 'fuente: <a href="https://www.miteco.gob.es/es/biodiversidad/servicios/banco-datos-naturaleza/informacion-disponible/ifn3.html">IFN3</a>'},
	notreedata: { "en": "No tree data",	
		"es": "Sin datos de árboles"},
	sampledplot: { "en": "1 plot",
		"es": "1 parcela "},
	sampledplots: { "en": " plots",	
		"es": " parcelas"},
	nosampledplots: { "en": "No plots",	
		"es": "Sin parcelas"},
	manualPlot: { "en": "Manually selected plot",	
		"es": "Parcela seleccionada manualmente"},
	blockedPlot: { "en": "Blocked plot",	
		"es": "Parcela bloqueada"},
	selectedPlot: { "en": "Selected plot",	
		"es": "Parcela seleccionada"},
	unselectedPlot: { "en": "Unselected plot",	
		"es": "Parcela no seleccionada"},
	isSelected: { "en": " is selected",	
		"es": " está seleccionada"},
	isUnselected: { "en": " is unselected",	
		"es": " no está seleccionada"},		
	select: { "en": "Select",	
		"es": "Seleccionar"},
	unselect: { "en": "Unselect",	
		"es": "Deseleccionar"},
	block: { "en": "Block",	
		"es": "Bloquear"},
	unblock: { "en": "Desbloquear",	
		"es": "Desbloquear"},
	delete: { "en": "Delete",	
		"es": "Borrar"},


	treesperha: { "en": "trees/ha",
		"es": "árboles/ha"},
	basalareamin: { "en": "basal area: ",
		"es": "área bas.: "},
	volumewithbarkmin: { "en": "vol. (OB): ",
		"es": "v. con cort.: "},
	volumewithoutbarkmin: { "en": "vol. (UB): ",
		"es": "v. sin cort.: "},
	treedensity: { "en": "tree density",
		"es": "densidad de árboles"},
	basalarea: { "en": "basal area",
		"es": "área basimétrica"},
	volumewithbark: { "en": "vol. over bark",
		"es": "vol. con corteza"},
	volumewithoutbark: { "en": "vol. under bark",
		"es": "vol. sin corteza"},		
	numbertreesHA: { "en": "#trees/ha",
		"es": "#árboles/ha"},
	basalareaHA: { "en": "basal area (m<sup>2</sup>/ha)",
		"es": "área basimétrica (m<sup>2</sup>/ha)"},
	basalareaHAmini: { "en": "basal area (m<sup>2</sup>/ha)",
		"es": "área bas. (m<sup>2</sup>/ha)"},
	volumewithbarkHA: { "en": "vol. over bark (m<sup>3</sup>/ha)",
		"es": "vol. con corteza (m<sup>3</sup>/ha)"},
	volumewithbarkHAmini: { "en": "vol. (OB) (m<sup>3</sup>/ha)",
		"es": "v. con cort. (m<sup>3</sup>/ha)"},
	volumewithoutbarkHA: { "en": "vol. under bark (m<sup>3</sup>/ha)",
		"es": "vol. sin corteza (m<sup>3</sup>/ha)"},
	volumewithoutbarkHAmini: { "en": "vol. (UB) (m<sup>3</sup>/ha)",
		"es": "v. sin cort. (m<sup>3</sup>/ha)"},	
	any: { "en": "any",
		"es": "cualquiera"},	
	plants: { "en": "Plants",
		"es": "Plantas"},
	plotfilter: { "en": "Configure plot filter",	
		"es": "Configura el filtro de parcela"},
	applyfilter: { "en": "Apply filter",	
		"es": "Aplicar filtro"},
	resetfilter: { "en": "Reset filter",
		"es": "Resetear filtro"},	
	plants: { "en": "Plants",
		"es": "Plantas"},
		
		
	color0: { "en": "Green",
		"es": "Verde",
		"pt": "Verde"},
	color1: { "en": "Gray",
		"es": "Gris",
		"pt": "Cinzento"},
	color2: { "en": "Blue gray",
		"es": "Gris azulado",
		"pt": "Cinzento azulado"},
	color3: { "en": "Orange",
		"es": "Naranja",
		"pt": "Laranja"},
	color4: { "en": "Blue",
		"es": "Azul",
		"pt": "Azul"},
	color5: { "en": "Pink",
		"es": "Rosa",
		"pt": "Rosa"},
	color6: { "en": "Purple",
		"es": "Violeta",
		"pt": "Roxo"},
	color7: { "en": "Indigo",
		"es": "Añil",
		"pt": "Azul índigo"},
	color8: { "en": "Cyan",
		"es": "Celeste",
		"pt": "Ciano"},
	color9: { "en": "Brown",
		"es": "Marrón",
		"pt": "Castanho"},
	
	
	searchplace: { "en": "Search place...",	
		"es": "Buscar lugar...",
		"pt": "Pesquisar lugar..."},
	noplacesfound: { "en": "No places matched",	
		"es": "No hay lugares que coincidan",	
		"pt": "Nenhum lugar encontrado"},
	population: { "en": "Population",
		"es": "Población",
		"pt": "População"},
	PPLC: { "en": "Capital of a country",
		"es": "Capital de país",
		"pt": "Capital de país"},
	PPLA: { "en": "Seat of an autonomous region",
		"es": "Capital de comunidad autónoma",
		"pt": "Capital de uma região autónoma"},
	PPLA2: { "en": "Seat of a province",
		"es": "Capital de provincia",
		"pt": "Capital de uma província"},
	PPLA3: { "en": "Municipality",
		"es": "Municipio",
		"pt": "Município"},
	PPLA4: { "en": "Populated place",
		"es": "Población",
		"pt": "Povoação"},
	PPL: { "en": "Populated place",
		"es": "Población",
		"pt": "Povoação"},
	FRST: { "en": "Forest",
		"es": "Bosque",
		"pt": "Floresta"},
	HLL: { "en": "Hill",
		"es": "Cerro",
		"pt": "Colina"},
	HLLS: { "en": "Hills",
		"es": "Cerros",
		"pt": "Colinas"},
	MT: { "en": "Mountain",
		"es": "Montaña",
		"pt": "Montanha"},
	MTS: { "en": "Mountains",
		"es": "Montañas",
		"pt": "Montanhas"},
	PRK: { "en": "Park",
		"es": "Parque",
		"pt": "Parque"},
	RDGE: { "en": "Ridge",
		"es": "Sierra",
		"pt": "Cume"},
	RES: { "en": "Reserve",
		"es": "Reserva",
		"pt": "Reserva"},
	RESF: { "en": "Forest reserve",
		"es": "Reserva forestal",
		"pt": "Reserva florestal"},
	RESN: { "en": "Nature reserve",
		"es": "Reserva natural",
		"pt": "Reserva natural"},
	RESW: { "en": "Wildlife reserve",
		"es": "Reserva natural",
		"pt": "Reserva natural"},
	VAL: { "en": "Valley",
		"es": "Valle",
		"pt": "Vale"},
	VALG: { "en": "Hanging valley",
		"es": "Valle glaciar",
		"pt": "Vale glaciar"},		
	
		
	manuallySelected:  { "en": "manually selected",
		"es": "manuales"}, 
	selected:  { "en": "selected",
		"es": "seleccionadas"}, 
	available: { "en": "available",
		"es": "disponibles"}, 
	filtered: { "en": "filtered",
		"es": "filtradas"}, 
	blocked: { "en": "blocked",
		"es": "bloqueadas"},
	bmanual: { "en": "Manual",
		"es": "Manuales"},
	bblocked: { "en": "Blocked",
		"es": "Bloqueadas"}, 
		
		
	provinces: { "en": "Provinces",
		"es": "Provincias"},
		
	
	polygons: { "en": "Polygons",
		"es": "Polígonos"},
	polygon: { "en": "Polygon",
		"es": "Polígono"},
		
	
	createPolygon: { "en": "Create a polygon",
		"es": "Crea un polígono"},
	drawPolygon: { "en": "Draw a polygon",
		"es": "Dibuja un polígono"},
	polygonToast: { "en": "Draw a polygon to select the plots inside it",
		"es": "Dibuja un polígono para seleccionar las parcelas contenidas"},
	draw: { "en": "Draw",
		"es": "Dibujar"},
	upload: { "en": "Upload",
		"es": "Subir"},
	cancel:  { "en": "Cancel",	
		"es": "Cancelar" },
	cancelPolygon:  { "en": "Cancel polygon",	
		"es": "Cancelar polígono" },
	finish:  { "en": "Finish",	
		"es": "Terminar" },
	finishPolygon:  { "en": "Finish polygon",	
		"es": "Terminar polígono" },
	deleteLastPoint:  { "en": "Delete last point",	
		"es": "Borrar último punto" },
	deleteLastPointDrawn:  { "en": "Delete last point drawn",	
		"es": "Borrar último punto dibujado" },
	startPolygon: { "en": "Click to start drawing the polygon.",
		"es": "Clica para empezar a dibujar el polígono."}, 
	contPolygon: { "en": "Click to continue drawing the polygon.",
		"es": "Clica para continuar dibujando el polígono."},
	endPolygon: { "en": "Click first point to close the polygon.",
		"es": "Clica el primer punto para cerrar el polígono."},
	errorPolygon: { "en": "<strong>Error:</strong> polygon lines cannot cross!",
		"es": "<strong>Error:</strong> ¡no pueden cruzarse las líneas del polígono!"},
	
	
	uploadPolygon: { "en": "Upload polygon",
		"es": "Subir polígono"},
	uploadText: { "en": "Upload a file with a polygon. Supported formats: \
		<ul><li>Shapefile (.shp)</li><li>GeoJSON (.json)</li><li>Well-known text (.wkt)</li></ul>",
		"es": "Sube un fichero con un polígono. Formatos permitidos: \
		<ul><li>Shapefile (.shp)</li><li>GeoJSON (.json)</li><li>Well-known text (.wkt)</li></ul>"},
	wgs84Text: { "en": 'Only the <strong>WGS 84</strong> (<a href="https://epsg.io/4326" target="_blank">EPSG:4326</a>) coordinate system is supported. Please convert your file to WGS 84 if necessary.',
		"es": 'Sólo se admite el sistema de coordenadas <strong>WGS 84</strong> (<a href="https://epsg.io/4326" target="_blank">EPSG:4326</a>). Por favor, convierte tu fichero a WGS 84 si es necesario.'},
	badCRS: { "en": "We only support polygons in the WGS 84 coordinate system.",
		"es": "Sólo admitimos polígonos en el sistema de coordenadas WGS 84." },
	outOfSpain: { "en": "Your polygon is out of Spain.",	
		"es": "Tu polígono está fuera de España." },
	unsupportedShape: { "en": "Unsupported shape type.",	
		"es": "Tipo de shapefile no soportado." },
	badGeoJSONorWKT: { "en": "Could not parse the uploaded file.",	
		"es": "No se pudo interpretar el fichero subido." },
	noGeoJSON: { "en": "Incorrect GeoJSON file.",	
		"es": "Fichero GeoJSON incorrecto." },
	noPolygon: { "en": "Incorrect geometry, we only support polygons.",	
		"es": "Geometría incorrecta, sólo admitimos polígonos." },
		
	
	downloadData: { "en": "Download data",
		"es": "Descargar datos"},
	noplots: { "en": "No plots to download!",
		"es": "¡No hay parcelas que descargar!"},
	downloadMessage: { "en": "You will retrieve all data of your selected plots, including sampled trees.",
		"es": "Obtendrás todos los datos de las parcelas seleccionadas, incluyendo los árboles muestreados."},
	downloadIFN: { "en": "Choose which Spanish inventory edition(s):",
		"es": "Elige qué edición(es) del inventario español:"},
	downloadNoIFN: { "en": "No inventory edition!",
		"es": "¡No hay edición de inventario!"},
	downloadFormatChoose: { "en": "Choose your preferred data format:",
		"es": "Elige el formato de datos:"},
	downloadNoFormat: { "en": "No format selected!",
		"es": "¡No hay formato seleccionado!"},
	downloaded: { "en": "downloaded",
		"es": "descargadas"},
	noPlotsDownloadedIFN2: { "en": "No NFI2 plots to download",
		"es": "No había parcelas del IFN2 para descargar"},
	noPlotsDownloadedIFN3: { "en": "No NFI3 plots to download",
		"es": "No había parcelas del IFN3 para descargar"},
	preparingFiles: { "en": "Preparing download files...",
		"es": "Preparando los ficheros de descarga..."},	
	downloadSuccess: { "en": "Download successful",
		"es": "Descarga de datos exitosa"},	
	close: { "en": "Close",
		"es": "Cerrar"},
	plotsFile: { "en": "plots_",
		"es": "parcelas_"},
	infoplotsFile: { "en": "plots_infoSpecies_",
		"es": "parcelas_infoEspecies_"},
	treesFile: { "en": "trees_",
		"es": "arboles_"},
	downloadFile: { "en": "downloadNFI",
		"es": "descargaIFN"},
		
	
		
	tourTitle0: { "en": "Welcome to NFI Downloader!",
		"es": "¡Bienvenido a Descarga IFN!"},
	tourText0: { "en": "This is a web application for downloading plot and tree data from the Spanish National Forestry Inventory (NFI).<br>Let's review the controls.<br><br><i>You can exit this tour at any time by pushing the 'X'.</i>",
		"es": " Esta aplicación web permite descargar los datos de parcelas y árboles del Inventario Forestal Nacional Español (IFN).<br>Empecemos revisando los controles.<br><br><i>Puedes salir de este tour en cualquier momento pulsando la 'X'.</i>"},
	tourTitle1: { "en": "Language",
		"es": "Idioma"},
	tourText1: { "en": "You can choose English or Spanish.",
		"es": "Puedes elegir el idioma español o el inglés."},
	tourTitle2: { "en": "The map",
		"es": "El mapa"},
	tourText2: { "en": "Plots are shown in an interactive map that you can control.<br>Use the touchscreen (or the mouse in PCs) for panning and zooming the map.",
		"es": "Las parcelas se muestran en un mapa interactivo por el que puedes navegar.<br>Usa la pantalla táctil (o el ratón si es un PC) para mover el mapa o para hacer zoom."},
	tourTitle3: { "en": "Zoom buttons",
		"es": "Botones de zoom"},
	tourText3: { "en": "You can also use these buttons for zooming in or out.",
		"es": "También puedes usar estos botones para controlar el nivel de zoom."},
	tourTitle4: { "en": "Search place",
		"es": "Buscar lugar"},
	tourText4: { "en": "Center the map in a specific a place by pushing this button and typing its name.",
		"es": "Centra el mapa en el lugar deseado tras pulsar este botón y teclear su nombre."},
	tourTitle5: { "en": "Map configuration",
		"es": "Configuración del mapa"},
	tourText5: { "en": "You can select the map type (satellite or default) and the administrative division (municipalities or provinces).",
		"es": "Puedes elegir el tipo de mapa (satélite o predeterminado) y la división administrativa (municipios o provincias)."},
	tourTitle6:{ "en": "IFN edition",
		"es": "Edición del IFN"}, 
	tourText6: { "en": "Select the desired edition of the NFI. Both NFI2 and NFI3 are available for use.<br><br><i>NFI4 will be soon available.</i>",
		"es": "Elige la edición del IFN que prefieras. Puedes escoger la edición IFN2 o la IFN3.<br><br><i>Próximamente estará disponible la edición IFN4.</i>"},
	tourTitle7: { "en": "Draw or upload a polygon",
		"es": "Dibuja o sube un polígono"},
	tourText7: { "en": "Draw a polygon or upload one from a file to select the plots contained.",
		"es": "Dibuja un polígono o sube uno desde un fichero para seleccionar las parcelas contenidas."},
	tourTitle8: { "en": "Filter taxon",
		"es": "Filtrar taxón"},
	tourText8: { "en": "Filter plots by taxon: you will get only the plots containing some tree of the selected taxon.",
		"es": "Filtra las parcelas por taxón: obtendrás solamente las parcelas con algún árbol del taxón seleccionado."},
	tourTitle9: { "en": "Taxa names",
		"es": "Nombres de taxones"},
	tourText9: { "en": "Toggle button to choose between scientific or vulgar taxon names.",
		"es": "Botón para elegir entre nombres taxonómicos científicos o vulgares."},
	tourTitle9a: { "en": "Configure a plot filter",
		"es": "Configura un filtro de parcela"},
	tourText9a: { "en": "Define the desired stock ranges for the plots.",
		"es": "Define los rangos de existencias deseados para las parcelas."},
	tourTitle9b: { "en": "Taxon information",
		"es": "Información de taxón"},
	tourText9b: { "en": "Get taxon information.",
		"es": "Obtén información del taxón."},
	tourTitle9c: { "en": "Taxon color",
		"es": "Color de taxón"},
	tourText9c: { "en": "Select the color of the taxon.",
		"es": "Elige el color del taxón."},
	tourTitle9d: { "en": "Remove taxon",
		"es": "Quitar taxón"},
	tourText9d: { "en": "Remove a filter taxon.",
		"es": "Elimina un filtro de taxón."},	
	tourTitle10: { "en": "Map features",
		"es": "Características del mapa"},
	tourText10: { "en": "You can interact with the different map features:<br><ul><li>View, select, or deselect provinces</li><li>View or delete polygons</li><li>View, select, deselect, or block plots</li></ul>",	
		"es": "Puedes interactuar con las diferentes características del mapa:<br><ul><li>Visualiza, selecciona o deselecciona provincias</li><li>Visualiza o borra polígonos</li><li>Visualiza, selecciona, deselecciona o bloquea parcelas</li></ul>"},
	tourTitle11: { "en": "# of selected plots",
		"es": "# de parcelas seleccionadas"},
	tourText11: { "en": "The number of selected plots is displayed here.",
		"es": "El número de parcelas seleccionadas se muestra aquí."},
	tourTitle12: { "en": "Download",
		"es": "Descarga"},
	tourText12: { "en": "Download the selected plots. Available formats: GeoJSON, CSV, and XLSX.",
		"es": "Descarga las parcelas seleccionadas. Los formatos disponibles son: GeoJSON, CSV y XLSX."},
	tourTitle13: { "en": "More options",
		"es": "Más opciones"},
	tourText13: { "en": "Push to go to the landing page or to change the language.",
		"es": "Pulsa para ir a la página de inicio o para cambiar el idioma."},		
	tourTitle14: { "en": "Tour",
		"es": "Tour"},
	tourText14: { "en": "Push this button to revisit this tour.",
		"es": "Pulsa este botón para volver a hacer este tour."},
	tourTitle15: { "en": "The end",
		"es": "Hemos terminado"},
	tourText15: { "en": "That\'s all for now.<br>Enjoy NFI Downloader!",
		"es": "Esto es todo por ahora.<br>¡Disfruta Descarga IFN!"},
	tourExit: { "en": "Exit",
		"es": "Salir"},
	tourNext: { "en": "Next",
		"es": "Siguiente"},
	tourBack: { "en": "Back",
		"es": "Atrás"},
	tourDone: { "en": "Done",
		"es": "Hecho"},
	
	
	questtext: { "en": "Could you take a moment<br>to answer a short questionnaire<br>to help us improve?",
		"es": "¿Podrías tomarte un momento<br>para responder un breve cuestionario<br>y ayudarnos a mejorar?"},
	questurl: { "en": "https://docs.google.com/forms/d/e/1FAIpQLSfEFaSb2xsl63GVgCHRi5EyCfWdHxuF1RavjkMAx232DRnEKA/viewform?usp=sf_link",
		"es": "https://docs.google.com/forms/d/e/1FAIpQLSdxTNAlSS6FfAevaIIuIdDvTOoAfLVc-cS2HhVYGQsipVG8og/viewform?usp=sf_link"},
	yes: { "en": "Yes",
		"es": "Sí",
		"pt": "Sim"},
	no: { "en": "No",
		"es": "No",
		"pt": "Não"},
	later: { "en": "Maybe later",
		"es": "Más tarde",
		"pt": "Talvez mais tarde"},
}